import { sendRequest } from "../../hooks/requests/useRequest";


export async function saveChangeAgreement(
    id_agreement_origen,
    id_agreement_destination,
    id_company,
    id_work_order,
    username,
    observation

) {

    const body = [{
        "id_agreement_origen": id_agreement_origen,
        "id_agreement_destination": id_agreement_destination,
        "id_company": id_company,
        "id_work_order": id_work_order,
        "username": username,
        "observation": observation

    }];


    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };


    const response = await sendRequest(
        requestOptions, `Microsite/UpdateChangeAgreement`
    );

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response.data
        }
    else
        return {
            code: response.code,
            data: response.data
        }
}


export async function GetHistoric(id_company) {
    let requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Microsite/GetHistoric?id_company=${id_company}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response.data
        }
    else
        return {
            code: response.code,
            data: response.data
        }
}